import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

import { Role } from '../../models';
import { AuthenticationService } from '../authentication.service';

import { RolesService } from '../roles.service';
import { FirestoreService } from './firestore.service';

interface RoleDTO {
    accessScope: string[];
    isAdmin: boolean;
    name?: string;
    translationKey?: string;
    permissions: string[];
}

@Injectable()
export class FirestoreRolesService implements RolesService {
    private rolesSubject: Subject<Role[]>;

    constructor(
        private authenticationService: AuthenticationService,
        private firestoreService: FirestoreService,
        private translateService: TranslateService,
    ) {
        this.rolesSubject = new ReplaySubject<Role[]>(1);
        this.init();
    }

    permissionsContains(permission: string, role?: Role): boolean {
        let permissions: string[] = [];

        if (!!role) {
            permissions = role.permissions ?? [];
        } else {
            permissions = this.authenticationService.user.role.permissions ?? [];
        }

        return permissions.includes(permission);
    }

    roles(): Observable<Role[]> {
        return this.rolesSubject.asObservable();
    }

    private init(): void {
        this.firestoreService
            .tenantDependentCollection(this.authenticationService.user.tenantId, 'roles')
            .snapshotChanges()
            .subscribe(
                (res) => {
                    const roles = res.map((d) => {
                        const roleDTO = d.payload.doc.data() as RoleDTO;
                        return {
                            accessScope: roleDTO.accessScope,
                            id: d.payload.doc.id,
                            isAdmin: roleDTO.isAdmin,
                            name: roleDTO.translationKey ? this.translateService.instant(roleDTO.translationKey) : roleDTO.name,
                            permissions: roleDTO.permissions,
                        };
                    });

                    this.rolesSubject.next(roles);
                },
                (error) => {
                    console.log(error);
                }
            );
    }
}
